import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { useAppSelector } from '../../hooks/store';
import PageWrapper from './PageWrapper';
import MainPage from '../../pages/MainPage';
import CompaniesPage from '../../pages/CompaniesPage';
import Profile from '../../pages/Profile';
import NotFound from '../../pages/NotFound';
import FullScreenLoading from '../../pages/FullScreenLoading';

function PrivateRoute() {
    const initDone = useAppSelector((state) => state.global.initDone);

    if (!initDone) {
        return <FullScreenLoading />;
    }

    return (
        <PageWrapper>
            <Routes>
                <Route path="/" element={<MainPage />} />
                <Route path="/companies" element={<CompaniesPage />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </PageWrapper>
    );
}

export default PrivateRoute;
